import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    selection: _ctx.state.selectedRow,
    "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.selectedRow) = $event)),
    filters: _ctx.filters,
    "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters) = $event)),
    class: "p-datatable-sm",
    "column-resize-mode": "fit",
    "resizable-columns": true,
    "responsive-layout": "scroll",
    lazy: true,
    page: _ctx.state.lazyParams.page,
    rows: _ctx.state.lazyParams.rows,
    "total-records": _ctx.state.lazyParams.total,
    "selection-mode": "single",
    value: _ctx.state.organizationGroup,
    "filter-display": "menu",
    paginator: true,
    "rows-per-page-options": [5, 10, 40],
    "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
    "current-page-report-template": `{currentPage} ${_ctx.t(
      'content.globalPagingInformation.ofTitle'
    )} {totalPages} ${_ctx.t('content.globalPagingInformation.pagesTitle')}`,
    "data-key": "id",
    loading: _ctx.state.dataLoading,
    onRowSelect: _ctx.onRowSelect,
    onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onPaginatorResearchEquipmentClick($event)))
  }, {
    paginatorend: _withCtx(() => []),
    empty: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("content.noData")), 1)
    ]),
    loading: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.t("content.globalLoadingText")), 1)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        "selection-mode": "single",
        style: {"width":"40px"},
        exportable: false
      }),
      _createVNode(_component_Column, {
        field: "number",
        header: 
        _ctx.t('content.dataManagement.content.organization.table.header.number')
      ,
        style: {"width":"5%"}
      }, {
        editor: _withCtx(({ data, field }) => [
          _createVNode(_component_InputText, {
            modelValue: data[field],
            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
            autofocus: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "name",
        header: 
        _ctx.t('content.dataManagement.content.organization.table.header.name')
      ,
        style: {"width":"20%"}
      }, {
        editor: _withCtx(({ data, field }) => [
          _createVNode(_component_InputText, {
            modelValue: data[field],
            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
            autofocus: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "websiteURL",
        header: 
        _ctx.t('content.dataManagement.content.organization.table.header.webURL')
      ,
        style: {"width":"20%"}
      }, {
        editor: _withCtx(({ data, field }) => [
          _createVNode(_component_InputText, {
            modelValue: data[field],
            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
            autofocus: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "street",
        header: 
        _ctx.t('content.dataManagement.content.organization.table.header.address')
      ,
        style: {"width":"20%"}
      }, {
        data: _withCtx(({ data, field }) => [
          _createVNode(_component_InputText, {
            modelValue: data[field],
            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
            autofocus: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "postalCode",
        header: 
        _ctx.t('content.dataManagement.content.organization.table.header.postalCode')
      ,
        style: {"width":"5%"}
      }, {
        data: _withCtx(({ data, field }) => [
          _createVNode(_component_InputText, {
            modelValue: data[field],
            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
            autofocus: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "city",
        header: 
        _ctx.t('content.dataManagement.content.organization.table.header.city')
      ,
        style: {"width":"10%"}
      }, {
        data: _withCtx(({ data, field }) => [
          _createVNode(_component_InputText, {
            modelValue: data[field],
            "onUpdate:modelValue": ($event: any) => ((data[field]) = $event),
            autofocus: ""
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, {
        field: "users",
        header: 
        _ctx.t('content.dataManagement.content.organization.table.header.contacts')
      ,
        style: {"width":"20%"}
      }, {
        body: _withCtx((slotProps) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data.users, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("p", null, _toDisplayString(item.firstname) + " " + _toDisplayString(item.lastname), 1)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 1
  }, 8, ["selection", "filters", "page", "rows", "total-records", "value", "current-page-report-template", "loading", "onRowSelect"]))
}